import clsx from 'clsx';
import type { CSSProperties, ReactNode } from 'react';
import { Avatar } from './primitives/marks.tsx';
import { Hint } from './primitives/shell.tsx';

/** Whose invite this browser holds, with their face: a member's to join, an analyst's to follow. */
export function InviteCard({
  picture,
  name,
  title,
  hint,
  className,
  style,
  children,
}: {
  picture: string | null;
  name: string;
  title: string;
  hint: string;
  className?: string;
  style?: CSSProperties;
  children?: ReactNode;
}) {
  return (
    <div
      className={clsx(
        'gate-in flex flex-col gap-3 rounded-box border border-accent/40 bg-accent/5 px-4 py-3',
        className,
      )}
      style={style}
    >
      <div className="flex items-center gap-3.5">
        <Avatar
          picture={picture}
          name={name}
          className="size-10 text-base ring-2 ring-accent/70 ring-offset-2 ring-offset-canvas"
        />
        <div className="flex min-w-0 flex-col gap-0.5">
          <p className="text-sm font-medium text-ink">{title}</p>
          <Hint>{hint}</Hint>
        </div>
      </div>
      {children}
    </div>
  );
}
